/**
 * Stats data for the dashboard KPI metrics
 * Following Next.js best practices - this is a pure data file
 */

export interface StatData {
  id: string;
  value: string | number;
  label: string;
  colorClass: string; // Tailwind color class
}

export const statsData: StatData[] = [
  {
    id: "stat-1",
    value: "1,500",
    label: "생산목표량",
    colorClass: "text-blue-600",
  },
  {
    id: "stat-2",
    value: "1,247",
    label: "금일 생산량",
    colorClass: "text-blue-600",
  },
  {
    id: "stat-3",
    value: "83.1%",
    label: "달성율",
    colorClass: "text-green-600",
  },
  {
    id: "stat-4",
    value: "78.5%",
    label: "진도율",
    colorClass: "text-purple-600",
  },
  {
    id: "stat-5",
    value: "15",
    label: "금일 불량수",
    colorClass: "text-red-600",
  },
  {
    id: "stat-6",
    value: "1.2%",
    label: "불량율",
    colorClass: "text-red-600",
  },
  {
    id: "stat-7",
    value: "3",
    label: "설비 비가동수",
    colorClass: "text-gray-700",
  },
  {
    id: "stat-8",
    value: "84.6%",
    label: "설비종합효율",
    colorClass: "text-green-600",
  },
  {
    id: "stat-9",
    value: "88.3%",
    label: "성능가동율",
    colorClass: "text-blue-600",
  },
  {
    id: "stat-10",
    value: "92.1%",
    label: "시간가동율",
    colorClass: "text-blue-600",
  },
];

